import {Component, OnInit, AfterViewInit, Output, EventEmitter, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CancelWarnings} from 'app/shared/models/cancel-warning';
import {CommonDataService} from 'app/services/common-data.service';

@Component({
    selector: 'cancel-warnings-table',
    templateUrl: './cancel-warnings-table.component.html',
    styleUrls: ['./cancel-warnings-table.component.css']
})
export class CancelWarningsTableComponent implements OnInit, AfterViewInit{

    constructor(public readonly translateService: TranslateService,
                public readonly commonData: CommonDataService){

        this.translateService.use(sessionStorage.getItem('userLocale'));
        this.change  = new EventEmitter();
        this.tooltipEnable = new Function('', '$("[data-toggle=tooltip]").tooltip({ boundary: "window" });');
    }


    @Output() change: EventEmitter<any>;

    @Input() private inputData: any[];
    @Input() private type: string;
    @Input() private typeModel: string;
    @Input() private TMForSelect: string;
    @Input() private hideInput: boolean;

    private readonly tooltipEnable: Function;
    private empty: boolean;
    public cancelData: CancelWarnings[] = [];
    public tooltip: string;
    public translatesTooltip: any;


    async ngOnInit(){
        this.translatesTooltip = await this.commonData.translateService.get(['OutEnableTooltip', 'OutDisableTooltip', 'WarningEnableTooltip', 'WarningDisableTooltip']).toPromise();
        await this.generateTable(this.inputData, this.cancelData, this.typeModel);
        this.tooltipEnable();
    }

    ngAfterViewInit(){

    }

    private resetTooltip = (): void =>{
        setTimeout(() =>{
            let $tooltips = $('[data-toggle="tooltip"]');
            $tooltips.tooltip('dispose');
            $tooltips.tooltip();
        },1)

    }

    public setApplyWarning = (cancelItem: CancelWarnings, data: any[], type: string): void => {

        this.resetTooltip();

        data.forEach(item => {
            if (item[cancelItem.name]){
                item[this.lowerCaseFirstLetter(type)] = cancelItem.enable ? 1 : 2;
            }
        });
    };

    public upperCaseFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    public lowerCaseFirstLetter(str: string): string {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }

    private objToArr (obj: any): string[] {
        if (obj instanceof Object){
            let arr: string[] = [];
                for (let prop in obj) {
                    arr.push(prop)
                }
            return arr;
        }
        return [];
    }

    private generateTable = async (data: any[], target: CancelWarnings[], propName: string): Promise<void> => {
        if (data.length > 0){
            const translate: string[] = [];

            let regExp = new RegExp(propName,"g");
            for (let targetKey in data[0]){
               if (targetKey.match(regExp)) {
                   let tooltip = [];
                   tooltip[1] = this.type === 'Out' ? 'OutEnableTooltip' : this.type === 'Warnings' ? 'WarningEnableTooltip': '';
                   tooltip[0] = this.type === 'Out' ? 'OutDisableTooltip' : this.type === 'Warnings' ? 'WarningDisableTooltip': '';
                   let cancelItem = new CancelWarnings(targetKey, true, null, '', tooltip);
                   translate.push(this.upperCaseFirstLetter(targetKey));
                   target.push(cancelItem);
               }
            }
            let translated = await this.commonData.translateService.get(translate).toPromise();
            target.forEach(item => {
                item.description = translated[this.upperCaseFirstLetter(item.name)];
                item.rowQuantity = 0;
                data.forEach(innerItem => {
                    innerItem[item.name] ? item.rowQuantity++ : item.rowQuantity;
                });
                if (item.rowQuantity > 0) this.empty = true;
            });
        }
    }

    private emitChange = (enable: boolean): void => {
        this.change.emit({type: this.type, enable: enable});
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/components/cancel-warnings-table.component/cancel-warnings-table.component.ts